import { useFeatureFlag } from "@/contexts/FeatureFlagContext"

/**
 * Single gate for every agent-chat affordance (page_context/held_file/tool-call
 * wiring in ChatInterface, the ask-agent button on answers, etc).
 *
 * Both flags are required: the backend only streams chat.completion.action /
 * tool-call events when AGENT_TOOLS is on, and the agent-loop request path
 * only exists on the v2 chat endpoint (RAG_V2_CHAT).
 */
export function useAgentChatEnabled(): boolean {
  const ragV2ChatEnabled = useFeatureFlag("RAG_V2_CHAT")
  const agentToolsEnabled = useFeatureFlag("AGENT_TOOLS")
  return ragV2ChatEnabled && agentToolsEnabled
}
